// @flow
import * as React from 'react'

import trendUp from 'images/trend-up.svg'
import trendSame from 'images/trend-same.svg'
import trendDown from 'images/trend-down.svg'

/**
 * Show an arrow for the trend
 * @param {number|string} props.previous Previous rank, can also be a string
 * (like "neu") – if it can't be parsed into a number, no arrow will be rendered
 * @param {number} props.current The current rank
 */
export function DisplacementArrow(props: {
  previous: number | string,
  current: number
}) {
  const previousRank = parseInt(props.previous, 10)
  let imageSrc = trendSame
  let trendClassName = 'trend-same'
  if (!isNaN(previousRank)) {
    const currentRank = props.current

    if (previousRank < currentRank) {
      imageSrc = trendDown
      trendClassName = 'trend-down'
    }

    if (previousRank > currentRank) {
      imageSrc = trendUp
      trendClassName = 'trend-up'
    }

    return (
      <img
        src={imageSrc}
        alt=''
        className={`ui mini inline spaced image displacement-arrow ${trendClassName}`}
      />
    )
  }

  return <span style={{ display: 'inline-block', width: '0' }} />
}

export default DisplacementArrow
